import React from 'react';

export default class RadioGroup extends React.Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
    }

    onChange(key) {
        this.props.onChange(this.props.name, key);

    }
    render() {
        return (
            <div>
                {!!this.props.title && <label className="input-label">{this.props.title}</label>}
                <div className="radio-container">
                    {this.props.options.map(item =>
                        <div key={item.key}>
                            <input type="radio" id={`${this.props.name}-${item.key}`}
                                name={this.props.name}
                                onChange={(this.onChange.bind(this, item.key))}
                                checked={this.props.value === item.key}
                                disabled={item.disabled} />
                            <label htmlFor={`${this.props.name}-${item.key}`}
                                className={`${(this.props.error || item.error) ? "error-label" : ""} ${item.disabled ? "disabled" : ""}`}>
                                {item.value}{item.tag}</label>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}





// WEBPACK FOOTER //
// ./src/components/commonComponents/util/RadioGroup.jsx